<template>
  <div class="fixed inset-0 flex justify-center items-center z-50 overflow-hidden
    bg-[rgba(0,0,0,0.5)] h-full w-full"
    :style="styleOverlay" v-if="getVisibleOverlays">
    <component :is="getOverlayComponent(getOverlay)"
               :overlay="getOverlay"
               class="w-full max-w-5xl max-h-[90%] p-4 bg-white rounded-lg
                overflow-auto break-words"/>
  </div>
</template>

<script>
// NOTE: LevelUpOverlayNoteComponent removed - handled via WebSocket in HomeComponent.vue
import TeamSelectionOverlayComponent
  from '@/components/Home/Shared/OverlayNotes/TeamSelectionOverlayComponent.vue';
import TagSelectionOverlayComponent
  from '@/components/Home/Shared/OverlayNotes/TagSelectionOverlayComponent.vue';
import HtmlOverlayComponent
  from '@/components/Home/Shared/OverlayNotes/HtmlOverlayComponent.vue';
import NewUserDemoOverlayComponent
  from '@/components/Home/Shared/FrontendOverlays/NewUserDemoOverlayComponent.vue';

export default {
  name: 'OverlayContainerComponent',
  components: {
    TeamSelectionOverlayComponent,
    TagSelectionOverlayComponent,
    HtmlOverlayComponent,
    NewUserDemoOverlayComponent,
  },
  computed: {
    getVisibleOverlays() {
      return this.$store.getters.visibleNoteOverlays;
    },
    getOverlay() {
      if (this.$store.getters.getOverlayNotes) {
        return this.$store.getters.getOverlayNotes[0];
      }

      return null;
    },
    styleOverlay() {
      if (this.getOverlay && this.getOverlay.event === 'newUserDemo') {
        return {
          zIndex: 1000,
        };
      }
      return {};
    },
  },
  methods: {
    getOverlayComponent(overlay) {
      if (!overlay) return null;
      switch (overlay.event) {
        // NOTE: rewardLevelUp is handled via WebSocket level_progress_update in HomeComponent.vue
        // Do not handle it here to avoid duplicate popups
        case 'chooseTeams':
          return 'TeamSelectionOverlayComponent';
        case 'chooseTags':
          return 'TagSelectionOverlayComponent';
        case 'htmlOverlay':
          return 'HtmlOverlayComponent';
        case 'newUserDemo':
          return 'NewUserDemoOverlayComponent';
        default:
          return null;
      }
    },
  },
};
</script>
<style scoped>
/* Ensure content inside overlay doesn't overflow */
.break-words {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* Ensure all child elements also wrap */
:deep(*) {
  max-width: 100%;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
